import {decorate, observable} from 'mobx';
import {BaseModel} from './base';
import i18n from '../i18n/i18n';
import {displayableProperty} from './displayableProperty';
import {displayablePropertyParam} from './displayablePropertyParam';

export class CockpitDashboard extends BaseModel {
  searchableProperties = ['name'];

  displayableProperties = [
    displayableProperty({
      key: 'name',
      title: i18n.t('cockpit.model.attributes.name'),
      params: [displayablePropertyParam({path: 'name'})],
    }),
  ];

  static prepareApiPayload(model) {
    return {
      id: model?.id,
      name: model.name,
      cockpitId: model.cockpitId,
      sortOrder: model.sortOrder,
      isLocked: model.isLocked,
    };
  }

  populateAttributesFromStore(rootStore) {
    super.populateAttributesFromStore(rootStore);
    this.cockpit = rootStore.cockpitStore.getById(this.cockpitId);
  }
}

decorate(CockpitDashboard, {
  id: observable,
  createdAt: observable,
  createdBy: observable,
  updatedAt: observable,
  updatedBy: observable,
  deletedAt: observable,
  deletedBy: observable,
  name: observable,
  cockpitId: observable,
  cockpit: observable,
  sortOrder: observable,
  isLocked: observable,
});
